<template>
  <admin-navbar>
    <h1 class="font-bold text-lg">
      Уулзалтад товлох эрхтэй хэрэглэгч шинээр нэмэх
    </h1>

    <YellowEditMeetingUser />

    <section class="flex flex-col bg-white rounded mt-10">
      <h6 class="text-base border-t-4 border-t-blue-500 rounded-t border-b p-3">
        Олон хэрэглэгч файлаар нэмэх
      </h6>

      <div v-if="!isLoading" class="p-3">
        <div class="flex flex-col w-full">
          <label for="userFile">
            Excel file:
            <span class="text-red-500">*</span>
          </label>
          <span class="mb-1 text-xs text-gray-500">
            .csv эсвэл excel файл оруулна уу. Файл нь доорх зураг дээрх шиг
            name, name_en, email, phone_number, user_type багануудтай байна.
            Өөрөөр оруулбал алдаа гарна.
          </span>
          <img
            src="../../../assets/images/miningMongolia/file-example.png"
            alt="example"
            class="w-1/2 mb-5"
          />
          <input
            id="userFile"
            name="userFile"
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            class="w-full p-2 border"
            @change="handleFileUpload"
          />
        </div>

        <button
          class="mt-3 px-4 py-2 bg-blue-500 text-white rounded"
          @click="submitFile"
        >
          Илгээх
        </button>
      </div>

      <div
        v-else
        class="flex justify-center items-center bg-white rounded mt-10 h-[20vh]"
      >
        <SpinLoading :color="'rgb(59 130 246)'" />
      </div>
    </section>
  </admin-navbar>

  <SuccessModal v-if="success" :success="success" />
  <ErrorModal v-if="error" :error="error" />
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import YellowEditMeetingUser from "@/containers/YellowPage/admin/YellowEditMeetingUser";
import { ref } from "vue";
import adminInstance from "@/lib/adminInstance.js";
import SuccessModal from "@/components/ui/SuccessModal";
import ErrorModal from "@/components/ui/ErrorModal";
import SpinLoading from "../../../components/ui/SpinLoading";

export default {
  name: "AdminYellowNewUser",
  components: {
    AdminNavbar,
    YellowEditMeetingUser,
    SuccessModal,
    ErrorModal,
    SpinLoading,
  },
  setup() {
    const userFile = ref(null);
    const success = ref(null);
    const error = ref(null);
    const isLoading = ref(false);

    const handleFileUpload = (event) => {
      userFile.value = event.target.files[0];
    };

    const submitFile = async () => {
      if (!userFile.value) {
        alert("Файл сонгоно уу!");
        return;
      }

      const formData = new FormData();
      formData.append("file", userFile.value);

      try {
        isLoading.value = true;
        const response = await adminInstance.post(
          "/yellow-page/upload/meeting-users",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200 && response.data.message) {
          error.value = response.data.message;
          setTimeout(() => {
            error.value = null;
          }, 5000);
        } else if (response.status === 200 && response.data.success) {
          success.value = "Амжилттай нэмэгдлээ.";
          setTimeout(() => {
            success.value = null;
          }, 5000);
        }
      } catch (error) {
        error.value = "Файл хадгалах үед алдаа гарлаа";
        setTimeout(() => {
          error.value = null;
        }, 5000);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      userFile,
      handleFileUpload,
      submitFile,
      success,
      error,
      isLoading,
    };
  },
};
</script>
